<a pButton
   [routerLink]="route()"
   [severity]="severity()"
   [class.w-full]="wide()"
   [class.max-w-60]="wide()"
   [queryParams]="routeQueryParams()"
   [size]="size()"
><span pButtonLabel>{{ buttonLabel() }}</span></a>
